import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../../services/tools/helpers.service';
import { EstacionariosService } from "../../../../../services/creditos/estacionarios.service";
import { CentroConsumoService } from "../../../../../services/creditos/centro-consumo.service";

@Component({
  selector: 'centro-consumo',
  templateUrl: './centro-consumo.component.html',
  styleUrls: ['./centro-consumo.component.scss']
})
export class CentroConsumoComponent implements OnInit {

  @Input() public idCreditos : number = null;
  @Input() public isCompleted : boolean = false;
  @Input() public idTipos_Creditos : number = null;
  @Input() public isEditable: boolean = false;
  @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
  //Cliente form
  public centro : any = {};
  public errors : any = {};
  private isInitialized : boolean = false;

  constructor(
    private helperService: HelpersService,
    private estacionariosService : EstacionariosService,
    private centroConsumoService : CentroConsumoService
  ){
  }

  ngOnInit() {
  }

  public loadComponent(){
    if(!this.isInitialized){
      this.getCentro(this.idCreditos);
      this.isInitialized = true;
    }
  }

  private getCentro(idCreditos : number){
    //TODO: Manejar cuando el id no retorna un aval valido
    this.estacionariosService.get(idCreditos).subscribe(
      (response)=>
      {
        const result = response.json().content;
        if(result.estacionario){
          //La información del centro se guarda dentro del modelo de la entidad Estacionario
          this.centro = result.estacionario;
        }          
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public save(){
    this.errors = {};

    let centro = this.centro;
    //Asigna el tipo de Crédito. Ya que hay campos que no se requieren para todos los créditos
    this.errors = this.centroConsumoService.validate(centro);

    if (Object.entries(this.errors).length > 0) {
    return false;
    }

    if(centro.id && centro.id > 0){
        //Actualiza la información
        this.update(centro);
    }else{
        //Create case
        console.error('El centro de consumo se creo desde el simulador, por lo tanto siempre debería ser un update y no un create')
    }      
  }

  private update(centro : any){      
    this.centroConsumoService.update(centro).subscribe(
        (response)=>
        {
          this.helperService.notification('Centro de consumo actualizado', 'Se ha actualizado exitosamente la información cel centro de consumo ', 'success');
          this.onDataUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/credigas-estacionario/detalles/components/centro-consumo/centro-consumo.component.ts